import { api, setAccessToken } from './client';
import type { AuthUser } from './auth';
import type { Difficulty, StreakView } from './puzzles';

export interface HistoryEntry {
  life_id: string;
  puzzle_date: string;
  difficulty: Difficulty;
  life_number: number;
  status: 'IN_PROGRESS' | 'WON' | 'LOST';
  won: boolean;
  final_score: number;
  target_score: number;
  moves_used: number;
  move_count: number;
  started_at: string;
  ended_at: string | null;
}

export interface HistoryPage {
  entries: HistoryEntry[];
  page: number;
  page_size: number;
  total: number;
}

export async function fetchMe(): Promise<{ user: AuthUser; streaks: StreakView[] }> {
  const res = await api.get('/api/me');
  return res.data;
}

export async function fetchHistory(params: {
  from?: string;
  to?: string;
  difficulty?: Difficulty;
  page?: number;
  page_size?: number;
}): Promise<HistoryPage> {
  const res = await api.get('/api/me/history', { params });
  return res.data;
}

export async function updateDisplayName(display_name: string): Promise<AuthUser> {
  const res = await api.patch('/api/me/display-name', { display_name });
  return res.data.user;
}

export async function updateEmailPreferences(prefs: {
  email_opt_out?: boolean;
  results_digest_opt_out?: boolean;
}): Promise<AuthUser> {
  const res = await api.patch('/api/me/preferences', prefs);
  return res.data.user;
}

export async function deleteAccount(): Promise<void> {
  await api.delete('/api/me');
  setAccessToken(null);
}

export async function unsubscribeByToken(token: string, type?: 'digest'): Promise<void> {
  await api.get('/api/email/unsubscribe', { params: type ? { token, type } : { token } });
}

export async function resubscribeByToken(token: string, type?: 'digest'): Promise<void> {
  await api.post('/api/email/resubscribe', type ? { token, type } : { token });
}
